import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_LOG } from './constants';
import { setLog } from './actions';
import { log } from '../services/game';
import { ensureCards } from '../Cards/sagas';

function* getLogTask(action) {
  const gameId = action.payload.get('gameId');
  // The entries name cards by id; the catalog says what they are.
  yield call(ensureCards);
  const entries = yield call(log, gameId);
  yield put(setLog(gameId, entries));
}

function* getLogWatcher() {
  yield takeLatest(GET_LOG, getLogTask);
}

export default [
  getLogWatcher,
];
